import { DateTime } from 'luxon';

export const formatOpenSearchDate = (date?: Date) => {
  if (!date) return undefined;

  return DateTime.fromJSDate(date).toISODate() ?? undefined;
};
